import { Table as TableBootstrap } from 'react-bootstrap';
import styled from 'styled-components';

export const Table = styled(TableBootstrap)`
  table {
    font-weight: 500;
  }

  thead {
    background: ${({ theme }) => theme.colors.tertiary};
    color: ${({ theme }) => theme.colors.textSecondary};
    border-radius: 0.5rem;

    th {
      font-weight: 500;
      border: 0;

      &:first-child {
        border-top-left-radius: 0.5rem;
        border-bottom-left-radius: 0.5rem;
      }

      &:last-child {
        border-top-right-radius: 0.5rem;
        border-bottom-right-radius: 0.5rem;
        text-align: end;
      }
    }
  }

  td:first-child {
    font-weight: 500;
  }

  td {
    vertical-align: middle;
    border: 0;
    color: ${({ theme }) => theme.colors.textPrimary};

    h6 {
      font-size: 1rem;
      color: ${({ theme }) => theme.colors.textPrimary};
      margin: 0;
    }

    p {
      font-size: 0.9rem;
      font-weight: 500;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      -webkit-line-clamp: 1;
      margin: 0;
    }
  }

  span {
    font-size: 0.9rem;
    color: ${({ theme }) => theme.colors.textPrimary};
  }

  tbody tr {
    transition: 0.3s ease-out;
    flex: 1;

    td {
      &:first-child {
        border-top-left-radius: 0.5rem;
        border-bottom-left-radius: 0.5rem;
      }

      &:last-child {
        border-top-right-radius: 0.5rem;
        border-bottom-right-radius: 0.5rem;

        button,
        a {
          background: transparent;
          color: ${({ theme }) => theme.colors.secondary};
          font-size: 1.2rem;
          border-radius: 8px;
          padding: 0.5rem;
          border: none;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;

          &:hover {
            background: ${({ theme }) => theme.colors.bg};
          }
        }

        div {
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }

  tbody tr:hover {
    background: ${({ theme }) => theme.colors.primary};
  }
`;

export const ButtonsSocialNetwork = styled.div`
  background: ${({ theme }) => theme.colors.primary};
  width: 155px;
  display: flex;
  justify-content: space-between;
  border-radius: 0.5rem;

  button {
    background: transparent;
    font-size: 0.9rem;
    border: 0;
    padding: 0.25rem 0.5rem;
    color: ${({ theme }) => theme.colors.textPrimary};
    font-weight: 500;
    transition: all 0.3s linear;

    &:first-child {
      border-top-left-radius: 0.5rem;
      border-bottom-left-radius: 0.5rem;
    }

    &:last-child {
      border-top-right-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
    }

    &.isActive {
      background: ${({ theme }) => theme.colors.secondary};
    }
  }
`;
